<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-04 15:58:57
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>通知模板管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="title"> </el-page-header>
          </div>
          <el-form
            label-position="right"
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="标题" prop="name">
              <el-input
                v-model="ruleForm1.name"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="跳转地址" prop="url">
              <el-input
                v-model="ruleForm1.url"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="事件类型" prop="type">
              <el-select
                v-model="ruleForm1.type"
                placeholder="请选择类型"
                style="margin-right: auto"
              >
                <el-option label="系统通知" value="0"></el-option>
                <el-option label="任务通知" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道类型" prop="type1">
              <el-checkbox-group v-model="ruleForm1.type1">
                <el-checkbox label="1">极光推送</el-checkbox>
                <el-checkbox label="2">短信</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="发送对象" prop="type2">
              <el-checkbox-group v-model="ruleForm1.type2">
                <el-checkbox label="1">用户</el-checkbox>
                <el-checkbox label="2">临勤</el-checkbox>
                <el-checkbox label="3">员工</el-checkbox>
                <el-checkbox label="4">保安公司</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="触发次数" prop="num">
              <el-select
                v-model="ruleForm1.num"
                placeholder="请选择类型"
                style="margin-right: auto"
              >
                <el-option label="多次触发" value="0"></el-option>
                <el-option label="单词触发" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="触发规则"
              v-if="ruleForm1.num == '0'"
              prop="list"
            >
              <div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;
                  "
                  v-for="(item, index) in ruleForm1.list"
                  :key="index"
                >
                  <el-select
                    v-model="item.type"
                    placeholder="请选择类型"
                    style="margin-right: auto"
                    @change="selectType('ruleForm')"
                  >
                    <el-option label="到点触发" value="0"></el-option>
                    <el-option label="提前触发" value="1"></el-option>
                    <el-option label="延迟触发" value="2"></el-option>
                  </el-select>
                  <!-- <el-form-item label="" prop="list"> -->
                  <el-input
                    placeholder="请输入分钟数"
                    v-model="item.time"
                    v-if="item.type != '0'"
                    style="margin-left: 20px"
                    @blur="selectType"
                  >
                    <template slot="append">分钟</template>
                  </el-input>
                  <!-- </el-form-item> -->
                  <i
                    class="el-icon-circle-plus-outline"
                    v-if="index == 0"
                    style="margin-left: 10px"
                    @click="addSelect"
                  ></i>
                  <i
                    class="el-icon-remove-outline"
                    v-if="index != 0"
                    style="margin-left: 10px"
                    @click="deleteSelect(index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="通知内容" prop="memo">
              <el-input
                type="textarea"
                v-model="ruleForm1.memo"
                placeholder="请输入通知内容"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 20px">
              <el-button
                @click="resetForm1('ruleForm')"
                style="margin-left: 50px"
                >取消</el-button
              >
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                style="margin-right: auto"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    system,
    quillEditor,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      title: "新增模板",
      ruleForm1: {
        name: "",
        url: "",
        type: "",
        num: "",
        memo: "",
        type1: [],
        type2: [],
        list: [{ type: "0", time: "" }],
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "change" }],
        num: [{ required: true, message: "必选项", trigger: "change" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        list: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const errors = [];
              value.forEach((item, index) => {
                if ((item.type == 1 || item.type == 2) && !item.time) {
                  errors.push(new Error(`触发规则时间不能为空`));
                }
              });
              callback(errors.length ? errors : undefined);
            },
            trigger: "blur",
          },
        ],
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      editId: "",
      input4: "",
      errors: [],
    };
  },
  created: function () {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.title = "编辑模板";
      this.getDetail();
    }
  },
  methods: {
    selectType(formName) {
      this.$refs.ruleForm.validateField("list", (errorMessage) => {});
    },
    addSelect() {
      let obj = {
        type: "0",
        time: "",
      };
      this.ruleForm1.list.push(obj);
    },
    deleteSelect(val) {
      this.ruleForm1.list.splice(val, 1);
    },
    goBack() {
      this.$router.go(-1);
    },
    handleAvatarSuccess(res, file) {
      let obj = {};
      obj.url = res.data;
      this.ruleForm1.img.push(obj);
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm1.name.length > 100) {
            this.$message({
              message: "标题最多输入100字",
              type: "warning",
            });
            return;
          }
          let param = {
            title: this.ruleForm1.name,
            categoryId: this.ruleForm1.type,
            detail: this.ruleForm1.memo1,
            brief: this.ruleForm1.memo,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/article/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally();
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/article/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally(() => {
                this.editId = "";
                this.ruleForm1.name = "";
                this.ruleForm1.type = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.memo1 = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/article/get/${this.editId}`)
        .then(({ data }) => {
          this.detail = data;
          this.ruleForm1.name = data.title;
          this.ruleForm1.type = data.categoryId;
          this.ruleForm1.memo = data.brief;
          this.ruleForm1.memo1 = data.detail;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
